import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Button, FormField, Icon, TextArea } from 'ui';
import AttachEntry from '../components/AttachEntry';

const FormEdit = ({
  t,
  isComment,
  commentGuid,
  onEdit,
  onClose,
  comment,
  files,
  attachedFiles,
  removeRecentlyAttached,
  onAttachComment,
  onRemoveAttachment,
}) => {
  const [value, setValue] = useState(comment || '');
  const [sendEnabled, setSendEnabled] = useState(true);
  const [currentFiles, setCurrentFiles] = useState(files || []);

  const MAX_CHARACTERS = 60000;
  const isAtCharacterLimit = value.length >= MAX_CHARACTERS;

  function onChange(e) {
    let formatted = e.currentTarget.value.substring(0, MAX_CHARACTERS);
    setValue(formatted);
    setSendEnabled(formatted.length > 1);
  }

  function editComment() {
    onEdit(commentGuid, value);
  }

  function removeAttachment(fileGuid) {
    onRemoveAttachment(fileGuid, commentGuid);
    setCurrentFiles(currentFiles.filter((file) => file.guid !== fileGuid));
  }

  return (
    <div className="form-delete-collection">
      <FormField isLabelHidden label={t('actions:Edit')}>
        <TextArea onChange={onChange} value={value} placeholder="" />
      </FormField>
      {isAtCharacterLimit && (
        <div className="message-sender__character-limit">
          <span className="message-sender__character-limit-text">{t('common:characterLimitReached', { quantity: MAX_CHARACTERS })}</span>
        </div>
      )}
      <br />
      <div className="form-edit-message__attachments">
        {currentFiles.map((file, k) => {
          return (
            <div className="post-card__attachment" key={k}>
              <div className="post-card__attachment-link">
                <div className="post-card__attachment-icon">
                  {/*<IconDLO type="attach" />*/}
                  <Icon name="attach" size="xl" />
                </div>

                <a
                  href={file.encoded_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t('buttons:Open file in new tab')}
                  title={t('buttons:Open file in new tab')}
                >
                  {file.encoded_url}
                </a>
              </div>
              <div className="post-card__attachment-remove" onClick={() => removeAttachment(file.guid)}>
                {/*<IconDLO type="close" />*/}
                <Icon name="close" size="xl" />
              </div>
            </div>
          );
        })}
      </div>
      <div className="upload-attach__uploader-list">
        {attachedFiles.map((content, k) => {
          return <AttachEntry key={k} guid={content.guid} name={content.name} size={content.size} onRemove={() => removeRecentlyAttached(content.guid)} />;
        })}
      </div>
      <div className="form-delete-collection__actions">
        <div className="form-edit-message__buttons">
          <div className="form-delete-message__buttons-left">
            {!isComment && (
              <div className="form-delete-message__attach" onClick={onAttachComment}>
                {/*<IconDLO type="attach" />*/}
                <Icon name="attach" size="xl" />
              </div>
            )}
          </div>
          <div className="form-delete-message__buttons-right">
            <div style={{ display: 'inline-block', float: 'right', width: '150px' }}>
              <Button variant="secondary-ghost" onClick={onClose} text={t('Cancel')} isFullWidth />
            </div>
            <div style={{ display: 'inline-block', float: 'right', width: '150px' }}>
              <Button isDisabled={!sendEnabled} variant="primary" onClick={editComment} text={t('Publish')} isFullWidth />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FormEdit.propTypes = {};

FormEdit.defaultProps = {
  files: [],
  attachedFiles: [],
};

export default withTranslation(['actions', 'buttons'])(FormEdit);
